import React, { useEffect, useState, useRef } from 'react';
import './JobDashboard.css';
import JobCard from './components/JobCard';
import HiredJobCard from './components/HiredJobCard';
import { NavLink } from 'react-router-dom';
import Loader2 from '../../components/loader2';
import { API_BASE_URL } from '../../config';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import DashboardNavbar from '../../components/Navbar/navbar-dashboard';
import Footer from '../../components/Footer/footer';

const ITEMS_PER_PAGE = 9; // Items per page for pagination

const JobDashboard = () =>
{
    const [jobsdata, setJobsdata] = useState([]);
    const [jobsCompleteData, setJobsCompleteData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentJobsPage, setCurrentJobsPage] = useState(1);
    const [currentHiresPage, setCurrentHiresPage] = useState(1);
    const scrollRef = useRef(null);

    const getAllJob = async () =>
    {
        try
        {
            const token = localStorage.getItem('token');
            if (token)
            {
                const decodeToken = jwtDecode(token);
                const homeUserId = decodeToken.nameid;
                console.log('homeUserId = ', homeUserId)
                if (homeUserId)
                {
                    const response = await axios.get(
                        `${API_BASE_URL}/api/Jobs/getmyjobs?homeUserId=${homeUserId}`
                    );
                    const jobs = response.data;
                    console.log(jobs);

                    //const getReversedJobs = (status) =>
                    //    jobs.filter((job) => job.jobStatus === status).reverse();

                    const getReversedJobs = (statuses) => {
                        // If statuses is not an array, wrap it in an array.
                        if (!Array.isArray(statuses)) {
                          statuses = [statuses];
                        }
                        return jobs.filter((job) => statuses.includes(job.jobStatus)).reverse();
                      };

                    setJobsdata(getReversedJobs(['Assigned', 'Pending']));
                    setJobsCompleteData(getReversedJobs(['Complete']));

                    setIsLoading(false);
                }
            }
        } catch (error)
        {
            setIsLoading(false);
            setError(error.message);
        } finally
        {
            setIsLoading(false);
        }
    };

    useEffect(() =>
    {
        setIsLoading(true);
        getAllJob();
    }, []);

    // Helper functions for pagination
    const paginate = (array, pageNumber, itemsPerPage) =>
    {
        const startIndex = (pageNumber - 1) * itemsPerPage;
        return array.slice(startIndex, startIndex + itemsPerPage);
    };

    const totalPages = (array) => Math.ceil(array.length / ITEMS_PER_PAGE);

    return (
        <>
            <DashboardNavbar prefix={'Biz '} />
            <section className="inner-page-banner">
                <div className="container">
                    <div className="row">
                        <h1 className="banner-heading">JOBS DASHBOARD</h1>
                    </div>
                    <NavLink
                        to="/jobOnboarding"
                        className="add_button_text2 btn theme_btn m-auto d-lg-table"
                    >
                        Add a new job
                    </NavLink>
                </div>
            </section>
            <div className="jobs-dashboard">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card-container">
                                <h2 className="inner-page-heading">My Jobs</h2>
                                <div className="card_sections">
                                    {isLoading && <Loader2 />}
                                    {!isLoading && (
                                        <div className="main-job-card-wrapper">
                                            {jobsdata.length > 0 ? (
                                                paginate(
                                                    jobsdata,
                                                    currentJobsPage,
                                                    ITEMS_PER_PAGE
                                                ).map((data) => (
                                                    <div key={data.job_id} className="job-card-main">
                                                        <JobCard data={data} id={data.job_id} />
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="no-jobs-found">
                                                    <p>No Jobs Found</p>
                                                </div>
                                            )}
                                            <div className="pagination-container">
                                                <div className="pagination">
                                                    {Array.from(
                                                        { length: totalPages(jobsdata) },
                                                        (_, index) => (
                                                            <button
                                                                key={index + 1}
                                                                onClick={() =>
                                                                    setCurrentJobsPage(index + 1)
                                                                }
                                                                className={
                                                                    index + 1 === currentJobsPage
                                                                        ? 'active'
                                                                        : ''
                                                                }
                                                            >
                                                                {index + 1}
                                                            </button>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {jobsCompleteData.length > 0 && (
                                <div className="card-container">
                                    <h2 className="inner-page-heading">My Hires</h2>
                                    <div className="card_section">
                                        {isLoading && <Loader2 />}
                                        {!isLoading && (
                                            <div className="main-job-card-wrapper">
                                                {paginate(
                                                    jobsCompleteData,
                                                    currentHiresPage,
                                                    ITEMS_PER_PAGE
                                                ).map((data) => (
                                                    <div
                                                        className="job-card-main"
                                                        key={data.job_id}
                                                    >
                                                        <HiredJobCard data={data} />
                                                    </div>
                                                ))}
                                                <div className="pagination-container">
                                                    <div className="pagination">
                                                        {Array.from(
                                                            { length: totalPages(jobsCompleteData) },
                                                            (_, index) => (
                                                                <button
                                                                    key={index + 1}
                                                                    onClick={() =>
                                                                        setCurrentHiresPage(index + 1)
                                                                    }
                                                                    className={
                                                                        index + 1 === currentHiresPage
                                                                            ? 'active'
                                                                            : ''
                                                                    }
                                                                >
                                                                    {index + 1}
                                                                </button>
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default JobDashboard;


// import React, { useEffect, useState, useRef } from 'react';
// import './JobDashboard.css';
// import JobCard from './components/JobCard';
// import HiredJobCard from './components/HiredJobCard';
// import { NavLink } from 'react-router-dom';
// import Loader2 from '../../components/loader2';
// import { API_BASE_URL } from '../../config';
// import axios from 'axios';
// import { jwtDecode } from 'jwt-decode';
// import DashboardNavbar from '../../components/Navbar/navbar-dashboard';
// import Footer from '../../components/Footer/footer';


// const JobDashboard = () =>
// {
//     const [jobsdata, setJobsdata] = useState([]);
//     const [jobsCompleteData, setJobsCompleteData] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const scrollRef = useRef(null);

//     const getAllJob = async () =>
//     {
//         try
//         {
//             const token = localStorage.getItem('token');
//             if (token)
//             {
//                 const decodeToken = jwtDecode(token);
//                 const homeUserId = decodeToken.nameid;
//                 if (homeUserId)
//                 {
//                     const response = await axios.get(`${API_BASE_URL}/api/Jobs/getmyjobs?homeUserId=${homeUserId}`);
//                     const jobs = response.data;
//                     const getReversedJobs = (status) => jobs.filter(job => job.jobStatus === status).reverse();
//                     setJobsdata(getReversedJobs('Pending'));
//                     setJobsCompleteData(getReversedJobs('Complete'));
//                     setIsLoading(false);
//                 }
//             }
//         } catch (error)
//         {
//             setIsLoading(false);
//             setError(error.message);
//         } finally
//         {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() =>
//     {
//         setIsLoading(true);
//         getAllJob();
//     }, []);

//     return (
//         <>
//             <DashboardNavbar prefix={'Biz '} />
//             <section class="inner-page-banner">
//                 <div class="container">
//                     <div class="row">
//                         <h1 class="banner-heading">JOBS DASHBOARD</h1>
//                     </div>
//                     <NavLink to="/jobOnboarding" className='add_button_text2 btn theme_btn m-auto d-lg-table'>
//                         {/* <Button title="Add A New Job" /> */}
//                         Add a new job
//                     </NavLink>
//                 </div>
//             </section>
//             <div className='jobs-dashboard'>
//                 {/* <div className='dashboard_header'>
//                     <img src={Banner} alt='Banner' className='banner-image' />
//                     <p className='dashboard_header_text'>JOBS DASHBOARD</p>
//                     <NavLink to="/jobOnboarding" className='add_button_text2'>
//                         <Button title="Add A New Job" />
//                     </NavLink>
//                 </div> */}

//                 <div className='container'>
//                     <div className='row'>
//                         <div className='col-sm-12'>

//                             <div className='card-container'>
//                                 <h2 class="inner-page-heading">My Jobs</h2>
//                                 <div className='card_sections '>

//                                     {isLoading && <Loader2 />}
//                                     {!isLoading && (
//                                         <div className='main-job-card-wrapper' >
//                                             {jobsdata.length > 0 ? (
//                                                 // {jobsdata.length > 0 ? (
//                                                 jobsdata.map((data) => (
//                                                     <div key={data.job_id} className='job-card-main'>
//                                                         <JobCard data={data} id={data.job_id} />
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <p>No Jobs Found</p>
//                                             )}
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             <div className='card-container'>
//                                 <h2 class='inner-page-heading'>My Hires</h2>
//                                 <div className='card_section'>
//                                     {isLoading &&
//                                         <Loader2 />
//                                     }
//                                     {!isLoading && (
//                                         <div className='main-job-card-wrapper' >
//                                             {jobsCompleteData.map((data) =>
//                                             {
//                                                 return (
//                                                     <div className='job-card-main'>
//                                                         <HiredJobCard data={data} key={data.id} />
//                                                     </div>
//                                                 );
//                                             })}
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </>
//     )
// }

// export default JobDashboard
